<template>
  <div>
    <section>
      <transition name="fade">
        <invite-team-member-popup v-if="showInviteTeamMember" class="invite-popup" :team="team" @close="showInviteTeamMember = false" />
      </transition> 
      <div class="over-table">     
        <div class="o-t-search">   
          <search-bar v-if="!mode" class="search-user" @input="searchMembers" />
          <div class="invite-people">
            <button class="clavo-button secondary" @click="showInvitePopup">
              {{ $t('invitePeople') }}
            </button>
          </div>
        </div>
        <div class="o-t-stats">
          {{$t('teamMebersInTotal')}}: {{ membersCount }} &nbsp;<span>|&nbsp; {{$t('active')}}:&nbsp;{{ activeMembersCount }}, {{$t('inactive')}}:&nbsp;{{ membersCount -  activeMembersCount}}</span>
        </div>       
      </div>
      <members-list
        :key="refreshMembers"
        :members="teamMembers"
        :searched-name="search"
        :members-loaded="membersLoaded"
        :keyword="keyword"
        :mode="mode"
        @reload-members="reloadInfiniteScroll"
      />
      <infinite-loading :identifier="infiniteId" spinner="spiral" @infinite="infiniteHandler">
        <div slot="spinner">
          <div class="spinner" />
        </div>
        <div slot="no-more" />
        <div slot="no-results" />
      </infinite-loading>
    </section>
  </div>
</template>

<script>
import SearchBar from '@/components/UI/SearchBar'
import User from '@/components/User'
import ParseFunctions from '@/components/ParseFunctions'
import MembersList from '@/components/Team/MembersList'
import InviteTeamMemberPopup from '@/components/Team/InviteTeamMemberPopup'
import EventBus from '@/EventBus'
import InfiniteLoading from 'vue-infinite-loading'
import Constants from '@/components/Constants'

export default {
  components: {
    MembersList,
    SearchBar,
    InviteTeamMemberPopup,
    InfiniteLoading,
  },
  mixins: [User, ParseFunctions, Constants],
  props: {
    team: Object,
  },
  data() {
    return {
      showInviteTeamMember: false,
      search: '',
      teamMembers: [],
      membersCount: 0,
      activeMembersCount: 0,
      placeholder: 'Search',
      refreshMembers: 0,
      page: 0,
      keyword: undefined,
      itemsPerPage: 30,
      infiniteId: +new Date(),
      membersLoaded: false,
      keywordTimeout: undefined,
      doneTypingInterval: 700,
      keywordInput: false,
      mode: undefined,
      connectUsersTitle: undefined,
      connectUsersDescription: undefined,
    }
  },
  computed: {
    currentTeam() {
      return this.$store.getters.teamById(this.$route.query.teamId)
    },
  },
  async created() {
    EventBus.$on('refresh-team-members', (input) => {
      this.reloadInfiniteScroll()
    })
    if (this.$route.query.mode) {
      this.mode = this.$route.query.mode
    }
  },
  beforeDestroy() {
    EventBus.$off('refresh-team-members')
  },
  methods: {
    async load() {
      this.infiniteId += 1
    },
    async infiniteHandler($state) {
      let beforePage = this.page
      let beforeKeyword = this.keyword
      let res

      res = await this.getTeamMembers(this.team.teamId, this.page, this.keyword, this.itemsPerPage)

      if (beforeKeyword !== this.keyword) {
        return
      }
      if (res.status === 'ok') {
        this.membersCount = res.membersCount
        this.activeMembersCount = res.activeMembersCount
        let membersGet = res.teamMembers
        if (membersGet.length !== 0) {
          this.page = beforePage + 1
          this.teamMembers.push(...membersGet)
          if (membersGet.length < this.itemsPerPage) {
            $state.complete()
            this.membersLoaded = true
            if (!this.keyword) {
              this.keywordInput = true
            }
          } else {
            $state.loaded()
            this.membersLoaded = false
            this.keywordInput = false
          }
        } else {
          $state.complete()
          this.membersLoaded = true
          if (!this.keyword) {
            this.keywordInput = true
          }
        }
        //this.$store.commit('setTeamMembers', this.teamMembers) - not used
      } else {
        this.showServerError(res)
      }
      // await this.$store.dispatch('reloadTeams')
    },
    showInvitePopup() {
      if (this.currentTeam.maxMembers - this.currentTeam.activeMembersCount > 0) {
        this.showInviteTeamMember = true
      } else {
        EventBus.$emit('new-info-bar-msg', {
          msg: this.$t('pleaseFixBillingBeforeAddingNewUsers'),
          error: true,
        })
      }
    },
    reloadInfiniteScroll() {
      this.membersLoaded = false
      this.keywordInput = false
      this.teamMembers = []
      this.page = 0
      this.infiniteId += 1
    },
    async searchMembers(input) {
      if (this.keywordInput) {
        this.search = input
      } else {
        clearTimeout(this.keywordTimeout)
        this.keywordTimeout = setTimeout(
          function () {
            this.keyword = input
            this.reloadInfiniteScroll()
          }.bind(this),
          this.doneTypingInterval,
        )
      }
    },
  },
}
</script>

<style lang="scss" scoped>
section {

  .invite-popup {
    position: absolute;
  }

  @include spinner;

  .over-table {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: sticky;
    padding: 18px;
    background: white;
    top: 0;
    z-index: 1;

    .o-t-stats {
      flex: 1;
      padding-top: 10px;
      margin-bottom: -8px;
      font-size: 14px;
      span {
        color: $amethyst;
        text-transform: lowercase;
        @include respond-below(sm) {
          display: inline;
        }
      }

      
    }  
    
    .o-t-search {
      display: flex; 
      flex-direction: row;
      justify-content: space-between;
      @include respond-below(xs) {
        flex-direction: column;
      }
    }

    .search-user {
      width: 60%;
    }
  }
  .arrows-box {
    position: relative;
    width: 50px;
    .arrow {
      position: absolute;
      &.right {
        right: 0;
      }
      &.left {
        transform: scaleX(-1);
        left: 0;
      }
    }
  }

  @include respond-below(sm) {
    .over-table {
      .search-user {
        flex: 1 1 auto;
        margin-right: 18px;
      }
    }
  }

  @include respond-below(xs) {
    .over-table {
      .search-user {
        width: 100%;
        align-self: stretch;
      }
      button {
        margin-top: 12px;
        width: 100%;
      }
    }
  }

  :deep(.list) {
    .headers {
      top: 104px;
      @include respond-below(xs) {
        top: 126px;
      }
    }
    
  }
}
</style>
